export default "__VITE_ASSET__9c6da74f__"